import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import * as LuIcons from 'react-icons/lu';
import SafeIcon from '../common/SafeIcon';
import { supabase } from '../lib/supabase';

const { LuCarFront } = LuIcons;

const DEFAULT_FOOTER = {
  footer_site_name: 'أوتو دي زد',
  footer_tagline: 'صُنع بـ ❤️ في الجزائر',
  footer_copyright: `© ${new Date().getFullYear()} جميع الحقوق محفوظة`,
  footer_bg_color: '#ffffff',
  footer_text_color: '#64748b',
};

const Footer = () => {
  const [footer, setFooter] = useState(DEFAULT_FOOTER);

  useEffect(() => {
    const fetchFooter = async () => {
      try {
        const { data } = await supabase.from('site_settings').select('setting_key, setting_value');
        if (data) {
          const mapped = { ...DEFAULT_FOOTER };
          data.forEach(row => {
            if (row.setting_key in mapped) mapped[row.setting_key] = row.setting_value;
          });
          setFooter(mapped);
        }
      } catch (err) {}
    };
    fetchFooter();
  }, []);

  return (
    <footer className="w-full mt-auto" style={{ backgroundColor: footer.footer_bg_color, borderTop: '1px solid #e2e8f0' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-emerald-600 rounded-xl flex items-center justify-center">
              <SafeIcon icon={LuCarFront} className="w-4 h-4 text-white" />
            </div>
            <span className="font-black text-lg" style={{ color: '#0f172a' }}>{footer.footer_site_name}</span>
          </div>
          <div className="flex flex-wrap justify-center items-center gap-4 sm:gap-6">
            <Link to="/about" className="text-sm font-bold hover:text-emerald-600 transition-colors" style={{ color: footer.footer_text_color }}>من نحن</Link>
            <Link to="/contact" className="text-sm font-bold hover:text-emerald-600 transition-colors" style={{ color: footer.footer_text_color }}>اتصل بنا</Link>
            <Link to="/reviews" className="text-sm font-bold hover:text-emerald-600 transition-colors" style={{ color: footer.footer_text_color }}>آراء الزبائن</Link>
            <Link to="/affiliate" className="text-sm font-bold hover:text-emerald-600 transition-colors" style={{ color: footer.footer_text_color }}>التسويق بالعمولة</Link>
          </div>
          <div className="text-center md:text-left">
            <p className="text-sm mb-1" style={{ color: footer.footer_text_color }}>{footer.footer_tagline}</p>
            <p className="text-xs" style={{ color: footer.footer_text_color }}>{footer.footer_copyright}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;